/**
 * @generated SignedSource<<9b70425499cc4aeb7de9f3257422f1f4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionCardActionsFragment$data = {
  readonly fromCompetition: {
    readonly currentStage: {
      readonly noCode: boolean;
      readonly submissionDeadline: DateTime | null | undefined;
    };
    readonly events: {
      readonly nodes: ReadonlyArray<{
        readonly event: {
          readonly slug: string;
        };
      }>;
    };
    readonly id: string;
    readonly slug: string;
    readonly title: string;
  } | null | undefined;
  readonly id: string;
  readonly publishedAt: DateTime | null | undefined;
  readonly submissions: {
    readonly nodes: ReadonlyArray<{
      readonly entity: {
        readonly username: string;
      };
      readonly id: string;
      readonly stage: {
        readonly events: {
          readonly nodes: ReadonlyArray<{
            readonly competition: {
              readonly slug: string;
              readonly title: string;
            };
            readonly event: {
              readonly slug: string;
            };
          }>;
        };
        readonly seq: number;
      };
    }>;
  };
  readonly version: Semver;
  readonly viewerCanPublish: boolean;
  readonly workspace: {
    readonly id: string;
    readonly slug: string;
    readonly viewerCanCreateVersion: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionPublishButtonFragment">;
  readonly " $fragmentType": "WorkspaceVersionCardActionsFragment";
};
export type WorkspaceVersionCardActionsFragment$key = {
  readonly " $data"?: WorkspaceVersionCardActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionCardActionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v1/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionCardActionsFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": "viewerCanPublish",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_WORKSPACE_VERSION\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": "viewerCanCreateVersion",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "CREATE_WORKSPACE_VERSION"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Competition",
      "kind": "LinkedField",
      "name": "fromCompetition",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v2/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionStage",
          "kind": "LinkedField",
          "name": "currentStage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submissionDeadline",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v3/*:: as any*/),
          "concreteType": "EventCompetitionConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventCompetition",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v4/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "events(first:1)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "SubmissionConnection",
      "kind": "LinkedField",
      "name": "submissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Submission",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionStage",
              "kind": "LinkedField",
              "name": "stage",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "seq",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v3/*:: as any*/),
                  "concreteType": "EventCompetitionConnection",
                  "kind": "LinkedField",
                  "name": "events",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventCompetition",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        (v4/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Competition",
                          "kind": "LinkedField",
                          "name": "competition",
                          "plural": false,
                          "selections": [
                            (v1/*:: as any*/),
                            (v2/*:: as any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "events(first:1)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "submissions(first:50)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionPublishButtonFragment"
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};
})();

(node as any).hash = "572d8973fd6afbb2e352645b40a1e54e";

export default node;
